import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const HoverButton = styled(Button)(
  (props) => `
  &&& {
    &:hover {
      background: ${
        !props.$isActive
          ? token('color.background.neutral.subtle.pressed', '#091E4224')
          : token('color.background.accent.blue.subtlest', '#E9F2FF')
      };
    }
    opacity: ${props.$isViewActionsOpen ? '1' : '0'};
    // overridden in ViewCard on hover
    width: ${props.$isViewActionsOpen ? '32px' : '1px'};
    padding: 0px;
    ${
      props.$isViewActionsOpen &&
      `
      background: ${
        props.$isViewActive
          ? token('color.background.accent.blue.subtlest', '#E9F2FF')
          : token('color.background.neutral.subtle.pressed', '#091E4224')
      };
    `
    }
  }
`
);
